import styled from 'styled-components';

import { filterSettingsFormStyles } from './filterSettingsFormStyles';

export const ManualFilterForm = styled.div`
  display: flex;
  flex-direction: column;

  ${filterSettingsFormStyles}
`;
